import LoginForm from "./LoginForm";
import { useTranslation } from "react-i18next";
import Meta from "services/Meta";

const Login = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("pages.login")} />
      <LoginForm />
    </>
  );
};

export default Login;
